import { gql, TypedDocumentNode } from "@apollo/client";

export type PhotoboothPerson = {
  id: string;
  pgaId: string;
  firstName: string;
  lastName: string;
  displayName: string;
  profilePhoto: string;
  addresses: {
    city: string;
    state: string;
    addressType: string;
  }[];
};

export type PhotoboothPersonSearchResponse = {
  people: {
    nodes: PhotoboothPerson[];
    totalCount: number;
  };
};

export type PhotoboothPersonSearchVariables = {
  input: {
    search: string;
  };
  first: number;
};

export const PHOTOBOOTH_PERSON_SEARCH_QUERY: TypedDocumentNode<
  PhotoboothPersonSearchResponse,
  PhotoboothPersonSearchVariables
> = gql`
  query PhotoboothPersonSearch($input: BackofficeCRMPeopleInput, $first: Int) {
    people(input: $input, first: $first) {
      totalCount
      nodes {
        id
        pgaId
        firstName
        lastName
        displayName
        profilePhoto
        addresses {
          city
          state
          addressType
        }
      }
    }
  }
`;
